export function getScrollSyncFn (a, b) {
  let ignoreEvent = false

  return (event) => {
    let ignore = ignoreEvent
    ignoreEvent = false

    if (ignore) {
      return
    }
    ignoreEvent = true

    if (event.target === a) {
      b.scrollTop = a.scrollTop
    } else {
      a.scrollTop = b.scrollTop
    }
  }
}
